import React, { useRef } from 'react'
import { useState } from "react"

import Paper from '@material-ui/core/Paper'
import { Grid } from "@material-ui/core"
import { makeStyles } from '@material-ui/core/styles'

import Toast from '@base/Toast'
import TextField from "@base/Inputs/Text"

import ObjetoPostalService from "@services/ObjetoPostalService"

import { isNotObjetoPostal } from "@helpers/ValidationHelper";

const __ENVELOPE_LENGTH = 13;
const __WAITING_TIME_TYPING = 300;

const useStyles = makeStyles(
	(theme) => (
		{
			wrapper: {
				padding: theme.spacing(2)
			},
			title: {
				color : "#333",
				fontSize: 24,
			}
		}
	)
);

export const BuscaObjetoPostal = (props) => {

	const [objetoPostal, setObjetoPostal] = useState("");
	const [timerTyping, setTimerTyping] = useState(0);

	const aoEncontrar =  props.aoencontrar  ? props.aoencontrar : () => {};
	const aoNaoEncontrar = props.aonaoencontrar ? props.aonaoencontrar : () => {};

	const toastRef = useRef(null);
	const classes = useStyles();

	const isObjetoPostalInvalido = (id) => {
		if (!id) return `<li>O campo 'Número do Objeto Postal' é obrigatório.</li>`;
		if (isNotObjetoPostal(id)) return `<li>O campo 'Número do Objeto Postal' precisa estar no formato <b>XX000000000XX</b>.</li>`;
	}

	const carregaInformacoesObjetoPostal = (tf) => {
		let id = tf.target.value?.toUpperCase();

		setObjetoPostal(id);
		clearTimeout(timerTyping);

		setTimerTyping(setTimeout(() => {
			if (id.length < 13) return;

			const objetoPostalInvalido = isObjetoPostalInvalido(id);
			if (objetoPostalInvalido) {
				toastRef.current.show("error", objetoPostalInvalido);
				return
			}

			ObjetoPostalService.getByNumero(props.processo.id, id).then(resposta => {
				if (resposta.status === 200) {
					aoEncontrar(resposta.data);
				} else {
					aoNaoEncontrar(id);
					toastRef.current.show("error", "Objeto postal não encontrado.");
				}
			}).catch(() => {
				aoNaoEncontrar(id);
				toastRef.current.show("error", "Objeto postal não encontrado.");
			});
		}, __WAITING_TIME_TYPING));
	}

	const textField =
		<Grid alignItems="center" container>
			<Grid item sm={props.size ?? 12}>
				<TextField
					ref={props.inputRef}
					{...props}
					label={"Número do Objeto Postal"}
					value={objetoPostal}
					onChange={carregaInformacoesObjetoPostal}
					inputProps={{ maxLength: __ENVELOPE_LENGTH }}
					helperText="Exemplo de Formato: XX000000000XX"
				/>
			</Grid>
		</Grid>

    return (
		<>
			<Toast ref={toastRef} />
			{ !props.ocultarsubtitulo ?
				<Paper className={classes.wrapper} elevation={0} spacing={2}>
					{textField}
				</Paper>
			:
				textField
			}
		</>
    );
}

export default BuscaObjetoPostal;
